import React from "react";
import { Col, Row, Space, Typography } from "antd";
import Countdown, { zeroPad } from 'react-countdown';
import { useTranslation } from "react-i18next";

const { Title } = Typography;

const ProductCountdown = ({ product }) => {
  const { t } = useTranslation();
  const deadline = product?.end_time || 0; // Moment is also OK
  // Renderer callback with condition
  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return null;
    } else {
      // Render a countdown
      return (
        <>
          <>
            <span className="split-number-item">
              <span className="number">{zeroPad(days)}</span>
              <span className="text">Dias</span>
            </span>
            <span className="split-number-item">
              <span className="number">{zeroPad(hours)}</span>
              <span className="text">Horas</span>
            </span>
            <span className="split-number-item">
              <span className="number">{zeroPad(minutes)}</span>
              <span className="text">Minutos</span>
            </span>
            <span className="split-number-item">
              <span className="number">{zeroPad(seconds)}</span>
              <span className="text">Seg</span>
            </span>
          </>

        </>
      );
    }
  };

  return (
    <div className="product-countdown">
      <Row align="middle">
        <Col>
          <Title level={5} className="product-countdown-title">{t("product.end")}</Title>
        </Col>
        <Col>
          <Space size={[0, 10]} wrap>
            <div className="product-countdown-wrapper split-number">
              <Countdown
                date={deadline}
                renderer={renderer}
              />
            </div>
          </Space>
        </Col>
      </Row>
    </div>
  );
};

export default ProductCountdown;

